import React, {useState} from 'react'
import './ShowOn.component.scss'
import banner_3 from '../images/banner_3.jpg'
import foto_4 from '../images/foto_4.png'
import foto_5 from '../images/foto_5.jpg'
import foto_6 from '../images/foto_6.jpg'
import foto_7 from '../images/foto_7.jpg'
import foto_8 from '../images/foto_8.jpg'
import plane1 from '../images/plane1.svg'
import plane2 from '../images/plane2.svg'
import plane3 from '../images/plane3.svg'
export enum Image {
    Image1,
    Image2,
    Image3,
    Image4,
    Image5

}
export default function ShowOn() {
    const [image, setImage] = useState<Image>(Image.Image2)
    const image_list = [foto_4, foto_5, foto_6, foto_7, foto_8]
    const image_type_list: Image[] = [Image.Image1, Image.Image2, Image.Image3, Image.Image4, Image.Image5]
    return (
        <div className={"showon"}>
            <h1 className={"label"}>SUPERIOR
                TRAVEL
                EXPERIENCE</h1>
            <img src={banner_3} alt="banner_3" className={"banner"}/>
            <div className={"image_label"}>
                Piper PA31-350 Chieftain<br />
                SE-FNE
            </div>
            <div className="showcase container flex">
                <img src={image_list[image]} alt=""/>
                <div className="content icons">
                    <img src={plane1} alt="plane1"/>
                    <img src={plane2} alt="plane2"/>
                    <img src={plane3} alt="plane3"/>
                </div>
            </div>
            <div className={"carousel_control"}>
                {
                    image_type_list.filter(x => x !== image).map(x => image_list[x]).map(
                        x => <img src={x} alt="" className={"image"} onClick={() => setImage(image_type_list[image_list.indexOf(x)])}/>
                    )
                }
            </div>
        </div>
    )
}